import { RouteRecordRaw } from 'vue-router'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/sign-in',
    name: 'sign-in',
    meta: { layout: 'AuthLayout' },
    component: () => import('@/pages/auth/index.vue'),
  },
]
